import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   updateUserManageTableColumns,
   ColumnSettings,
   UpdateUserManageTableColumnsResult,
} from '~/monolith-api';

export type { ColumnSettings, UpdateUserManageTableColumnsResult };

const updateUserManageTableColumnsSchema = z.object({
   column_settings: z.array(
      z.object({
         user_attribute: z.enum([
            'name',
            'email',
            'privilege',
            'status',
            'date_created',
            'last_login',
            'job_title',
            'department',
            'shift',
            'location',
            'plant',
            'address_line_1',
            'address_line_2',
            'city',
            'country_region',
            'state_province',
            'postal_code',
            'zone_code',
            'employment_type',
            'job_type',
            'date_started',
            'date_terminated',
            'employee_id',
            'preferred_name',
            'company',
            'division',
            'manager_name',
            'manager_employee_id',
            'group',
            'group_code',
            'job_code',
            'employment_status',
            'preferred_language',
         ]),
         hidden: z.boolean(),
         column_order: z.number(),
      })
   ),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { column_settings } = updateUserManageTableColumnsSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await updateUserManageTableColumns(column_settings, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const updateUserManageTableColumnsFromClient = (
   column_settings: Array<ColumnSettings>
): ReturnType<typeof updateUserManageTableColumns> => {
   return bff()
      .post('/users/updateUserManageTableColumns', {
         column_settings,
      })
      .then(response => response.data);
};
